import Paper from '@mui/material/Paper';
import React from 'react';
import { connect } from 'react-redux';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import StationInformation from '@sophocles/views/admin/engineering/stationInfo/StationInfo';
import { rawFetchStationInfo } from '@sophocles/views/admin/engineering/stationInfo/StationInfoActions';

class StationPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  _setLoading = loading => this.setState({ loading });

  render() {
    const { customer } = this.props;
    const { loading } = this.state;

    const pageTitle = 'Weather Lookup';

    return (
      <AppNav {...this.props} loading={loading} page="admin_home" notFullHeight={true}>
        <div className="container-fluid" style={{ top: '64px', height: '100%', margin: '0 16px' }}>
          <TitleBar showBackButton title={pageTitle} />
          <div className="row" style={{ height: 'calc(100% - 64px)' }}>
            {/* Left Filter Section */}
            {/* Right Section */}
            <Paper style={{ width: '100%', height: '100%', marginBottom: '16px' }}>
              <StationInformation {...this.props} setLoading={this._setLoading} />
            </Paper>
          </div>
        </div>
      </AppNav>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    fetchData: (latitude, longitude, weather_range_km) =>
      dispatch(rawFetchStationInfo(latitude, longitude, weather_range_km)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StationPage);
